import {
  SeasonTicketStoreItem,
  TicketSearch,
  TicketStoreItem,
  TicketsType,
} from '@givebacks/api/store';
import { createTable } from 'core/Packages';

type TableInstanceMeta = {
  causeId: string;
  campaignId: string;
  ticketsType: TicketsType;
};
type TicketTableData = TicketStoreItem | SeasonTicketStoreItem;

const TicketsTableInstance = createTable<TicketTableData, TicketSearch, TableInstanceMeta>();

export { TicketsTableInstance };
export type { TicketTableData };
